<template>
    <div class="card is-shadowless">
        <div class="card-header is-shadowless">
            <h3 class="card-header-title">
                Los mejores Gremios
            </h3>
            <p v-show="false">Ranking de guilds, los mejores guild del juego y sus miebros.</p>
        </div>
        <div class="card-content is-paddingless">
            <table class="table is-hoverable is-fullwidth" v-if="rankingItems.length > 0">
                <thead>
                    <tr class="has-text-justified">
                    <th>Pos.</th>
                    <th>Nombre</th>
                    <th>Puntos</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rank, n) in rankingItems" :key="n" @click="goToDetail(rank.name)" class="clickeable-box has-text-justified">
                        <td>
                            <fa icon="trophy" :class="{'gold-color':n==0,'silver-color':n==1,'bronze-color':n==2}" />
                        </td>
                        <td>{{rank.name}}</td>
                        <td>{{rank.score}}</td>
                    </tr>
                </tbody>
            </table>
            <p v-else>Próximamente...</p>
        </div>
        <div class="card-footer" v-if="rankingItems.length > 0">
            <router-link to="/ranking/gremios" class="card-footer-item has-text-primary">Ver más</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name:'HomeRankingSection',
    computed: {
        api() {
            return this.$store.getters.GetApiPath
        },
        rankingItems() {
            return this.$store.getters.GetTop3Guild
        }
    },
    methods: {
        goToDetail(guild) {
            this.$router.push(`/gremios/${guild}`)
        }
    }
}
</script>

<style>

</style>